import { createStoreChunk } from '@core/store'

import { type TPaywallCloseReason, type TPaywallRequest } from '../types/paywallTypes'

// Plain data only, no nodes: the container resolves `variant` into copy.

type TPaywallState = {
    request: TPaywallRequest | null
    closeReason: TPaywallCloseReason | null
}

export const paywallStore = createStoreChunk<TPaywallState>('paywall')({
    initialState: { request: null, closeReason: null },
})
